<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle}}</span>
      <button (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>



  <div *ngIf="eventType == 'event'">

    <div mat-dialog-content class="p-24 m-0" eguardPerfectScrollbar>

      <form name="eventForm" [formGroup]="eventForm" class="event-form w-100-p" fxLayout="column" fxFlex>

        <mat-input-container class="w-100-p">
          <input matInput name="title" formControlName="title" placeholder="Title" required [disabled]="isLoading">
        </mat-input-container>

        <div fxFlex="1 0 auto" fxLayout="row">
          <md2-datepicker class="w-100-p" format="MMM/d/y H:mm A" openOnFocus="true" placeholder="Start Date/Time"
            formControlName="start" type="datetime">
          </md2-datepicker>

        </div>


        <div fxFlex="1 0 auto" fxLayout="row">
          <md2-datepicker class="w-100-p" format="MMM/d/y H:mm A" openOnFocus="true" placeholder="End Date/Time"
            formControlName="end" type="datetime">
          </md2-datepicker>
        </div>
        <p class="error center-block"> {{ uiError }} </p>
        <mat-input-container formGroupName="meta" class="w-100-p">
          <mat-select placeholder="Location" formControlName="location">
            <mat-option *ngFor="let loc of locations" [value]="loc.value">
              {{ loc.viewValue }}
            </mat-option>
          </mat-select>
        </mat-input-container>

        <mat-input-container formGroupName="meta" class="w-100-p">
          <mat-select placeholder="Cases" #t (change)="showContacts(t.value)" formControlName="cases">
            <mat-option *ngFor="let case  of casesArray" [value]="case.id">

              <span *ngIf="case.summary.case_number"> {{ case.summary.case_number}}</span>
              <span *ngIf="!case.summary.case_number"> Ward-{{ case.ward.name}}</span>
            </mat-option>
          </mat-select>
        </mat-input-container>

        <mat-input-container formGroupName="meta" class="w-100-p" *ngIf="caseContacts && caseContacts.length">
          <mat-select placeholder="Recipients" multiple formControlName="user_ids"
            [disabled]="caseContacts.length === 0">
            <mat-option *ngFor="let contacts of caseContacts" [value]="contacts.user_id">
              {{ contacts?.first_name }} {{ contact?.last_name}}
            </mat-option>
          </mat-select>
        </mat-input-container>

        <mat-input-container formGroupName="meta" class="w-100-p">
          <textarea matInput rows="6" cols="100" formControlName="notes" placeholder="Notes" mat-maxlength="500"
            max-rows="12">
                </textarea>
        </mat-input-container>

      </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center"
      style="float: right;width: 100%;">
      <button *ngIf="action ==='edit'  && (createdById === userId)" mat-button class="mat-icon-button"
        (click)="deleteEvent()" aria-label="Delete" mat-tooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
      <button *ngIf="action !=='edit'" [class.loading]="loading" mat-raised-button color="accent" (click)="saveEvent()"
        style="margin-left: auto" class="save-button mat-accent" [disabled]="eventForm.invalid || loading"
        aria-label="SAVE">
        <div class="spinner"></div>
        <span class="label">SAVE</span>
      </button>

      <button [class.loading]="loading" *ngIf="action ==='edit' && (createdById === userId)" style="margin-left: auto"
        [disabled]="createdById != userId || loading" mat-raised-button color="accent" (click)="putEvent()"
        class="save-button mat-accent" [disabled]="eventForm.invalid || loading" aria-label="SAVE">
        <div class="spinner"></div>
        <span class="label">SAVE</span>
      </button>



    </div>
  </div>

  <div *ngIf="eventType == 'task'">
    <div mat-dialog-content class="p-24 m-0" eguardPerfectScrollbar>

      <form name="eventForm" [formGroup]="taskForm" class="event-form w-100-p" fxLayout="column" fxFlex>

        <mat-input-container class="w-100-p">
          <input matInput name="title" formControlName="title" placeholder="Title" required>
        </mat-input-container>

        <div fxFlex="1 0 auto" fxLayout="row">
          <md2-datepicker class="w-100-p" format="MMM/d/y H:mm A" openOnFocus="true" placeholder="Start Date/Time"
            formControlName="start" type="datetime">
          </md2-datepicker>
        </div>

        <mat-input-container formGroupName="meta" class="w-100-p">
          <textarea matInput rows="6" cols="200" formControlName="notes" placeholder="Notes" mat-maxlength="500"
            max-rows="12">
                  </textarea>
        </mat-input-container>

      </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center"
      style="float: right;width: 100%;">

      <button *ngIf="action ==='edit' && (createdById === userId)" mat-button class="mat-icon-button"
        (click)="deleteEvent()" aria-label="Delete" mat-tooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
      <button [class.loading]="loading" *ngIf="action !=='edit'" mat-raised-button color="accent" (click)="saveTask()"
        style="margin-left: auto" class="save-button mat-accent" [disabled]="taskForm.invalid || loading"
        aria-label="SAVE">
        <div class="spinner"></div>
        <span class="label">SAVE</span>
      </button>



      <button [class.loading]="loading" *ngIf="action ==='edit' && (createdById === userId)" style="margin-left: auto"
        [disabled]="createdById != userId || loading" mat-raised-button color="accent" (click)="putTask()"
        class="save-button mat-accent" [disabled]="taskForm.invalid || loading" aria-label="SAVE">
        <!-- <div *ngIf="!loading">SAVE</div> -->
        <div class="spinner"></div>
        <span class="label">SAVE</span>
      </button>


    </div>
  </div>


</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/calendar/event-form/event-form.component.html